<div class="chl-donations__list" #donationEl>
  @for (item of items; track item.amount; let i = $index) {
    <label
      class="chl-donations-item"
      [class.chl-donations-item--active]="control.value === i"
      cheeleeOpenGetApp
      picture="lee"
      [preventDefault]="false"
      [eventName]="analyticsEvents.DonateValueTap"
    >
      <input
        type="radio"
        class="chl-donations-item__input"
        [value]="i"
        [formControl]="control"
      />
      {{ (control.value === i ? 'Donate ' : '') + item.amount + ' ' + item.currency + ' ' + item.icon }}
    </label>
  }
</div>
